import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-lamp-stack-dev',
  templateUrl: './hire-lamp-stack-dev.component.html',
  styleUrls: ['./hire-lamp-stack-dev.component.css']
})
export class HireLampStackDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-lamp-stack-dev/hire-lamp-stack-dev.component.ts